<template>
  <div>
    <form>
      <div class="row">
        <div class="col-sm-12">
          <div class="form-group m-b-10">
            <label class="col-form-label control-label required">{{
              $t('fileManager.name')
            }}</label>
            <div>
              <input
                type="text"
                class="form-control"
                v-model="model.name"
                :class="{ 'is-invalid': errors.has('name') }"
                autofocus
                @focus="$event.target.select()"
                ref="name"
              />
              <div class="invalid-feedback" v-if="errors.has('name')">
                {{ errors.first('name') }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row ts-mt-6">
        <div class="col-sm-12 col-lg-12 col-md-12 text-right">
          <ts-button
            class="btn-sm"
            @click.prevent="$emit('close')"
            :disabled="saving"
            >{{ $t('cancel') }}</ts-button
          >
          <ts-button
            color="primary"
            class="ml-2 btn-sm"
            :waiting="saving"
            @click.prevent="createDirectory"
            >{{ $t('create') }}</ts-button
          >
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'

export default {
  props: ['data'],
  name: 'create-folder',
  data () {
    return {
      model: {
        parent_id: null,
        name: 'Untitled directory'
      },
      errors: new Errors(),
      saving: false
    }
  },
  mounted () {
    this.$nextTick(function () {
      this.$refs.name.focus()
    })
  },
  methods: {
    createDirectory () {
      this.errors = new Errors()
      this.saving = true
      this.$store
        .dispatch(
          'fileManager/fileFunction/createFolder',
          Object.assign({}, this.model, { parent_id: this.data.id })
        )
        .then(response => {
          this.$store.commit(
            'fileManager/fileBrowser/SET_CURRENT_FOLDER_ID',
            response.data.id
          )
          this.$store.commit(
            'fileManager/fileBrowser/SET_CURRENT_FOLDER',
            response.data
          )
          this.$store.commit(
            'fileManager/fileBrowser/CREATE_NEW_FOLDER_STATUS',
            response.data.id
          )
          this.model.parent_id = null
          this.model.name = 'Untitled directory'
          this.saving = false
          this.$toasted.success(response.message)
          // this.$emit('created')
          this.$emit('close')
          this.$router.push({
            name: 'file-manager-folder',
            params: { id: response.data.id }
          })
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.saving = false
        })
    }
  }
}
</script>
